import React from "react";
import * as TS from "../style/atPartner-style";
import { BackArrow } from "../style/webbutv-details-style";
import { BokaMote } from "../style/bokaMote";
import LM from "../../assets/portraits/LM_portrait.jpg";

export const ATPartner: React.FC = () => {
    return (
        
        <TS.AtPartOuterContainer>
            <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "90%",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <BackArrow />
      </div>

               <TS.AtPartTopH3>Tjänster – Andtech Partner</TS.AtPartTopH3>
                  <TS.AtPartH2>Andtech Partner</TS.AtPartH2>
                  <TS.UnderlineAtPartner />
        


                <TS.FullWidthDiv>
                 <TS.SectionH4>
                    {`Andtech Partner – IT-stöd för bolag i tillväxt`}
                </TS.SectionH4>
                <TS.SectionP>
                    {`Företag som växer snabbt stöter ofta på samma problem: systemen räcker inte till, arbetet blir mer manuellt, och tekniken hänger inte med. Många är beroende av Excel-lösningar, manuella processer och enskilda nyckelpersoner för att få vardagen att fungera.

                    Andtech Partner är ett abonnemang där ni får tillgång till ett erfaret utvecklingsteam – utan att behöva anställa, upphandla eller driva tekniska projekt själva. Vi fungerar som en förlängning av er verksamhet och hjälper till med både utveckling och teknisk rådgivning.`}
                </TS.SectionP>
            </TS.FullWidthDiv>


            <TS.TwoSectionGrid>
                <TS.InnerColumn>
                <TS.SectionH4>
                    Vad är Andtech Partner?
                </TS.SectionH4>
                <TS.SectionP>
                    {`Andtech Partner är ett abonnemang där vi fungerar som din externa IT-avdelning i den utsträckning du vill. 
                    Du får tillgång till vårt team av utvecklare och designers, utan att behöva anställa eller ta in dyra konsulter. 
                    
                    Med ett flexibelt antal timmar per månad hjälper vi till att digitalisera manuella processer, koppla ihop system och fatta bättre tekniska beslut.Så att du kan lägga fokus där det gör mest nytta, på tillväxt och kundvärde.`}
                </TS.SectionP>
                </TS.InnerColumn>

            
                  <TS.InnerColumn>
                <TS.SectionH4>
                    Är det viktigt?
                </TS.SectionH4>
                <TS.SectionP>
                    {`Ja! När verksamheten växer räcker det sällan med tillfälliga lösningar, excelark och mejltrådar. 
                    Tekniken behöver hänga med, annars blir det snabbt krångligt, ineffektivt och svårt att få en tydlig överblick. Vilket gör det svårt att skala upp och prioritera rätt.

Med Andtech Partner får du tillgång till ett erfaret team som förstår både teknik och affär. Vi ser till att din digitala vardag fungerar, med smarta lösningar som frigör tid, minskar personberoende och skapar bättre kontroll.
`}
                </TS.SectionP>
                </TS.InnerColumn>
            </TS.TwoSectionGrid>

            <TS.FullWidthDiv>
                 <TS.SectionH4>
                   Hur funkar det i praktiken?
                </TS.SectionH4>
                <TS.SectionP>
                    {`Du abonnerar på ett antal timmar per månad – vi står för kompetensen. Vi börjar med att lära känna din verksamhet och era utmaningar, prioriterar insatserna tillsammans och stöttar löpande. Det kan handla om att automatisera flöden, bygga egna verktyg, integrera system eller avlasta med AI-stöd. Vi är ett litet team med bred erfarenhet – och vårt fokus är att du snabbt får rätt kompetens, utan krångel.`}
                </TS.SectionP>
            </TS.FullWidthDiv>

 <BokaMote 
          name="Lena" 
          img={LM} 
          text="Boka ett möte med {name}." 
          email="hello@andtech.se"
          subject="Bokningsförfrågan: Möte med Lena"
          body="Hej Lena, Jag är intresserad av att veta mer om webbutveckling & CMS och skulle gärna boka ett möte med dig."
      />   
        </TS.AtPartOuterContainer>
    );
}


